/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Get_StartedInputs */

const en_ui_onboarding_get_started = /** @type {(inputs: Ui_Onboarding_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started`)
};

const de_ui_onboarding_get_started = /** @type {(inputs: Ui_Onboarding_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los geht's`)
};

/**
* | output |
* | --- |
* | "Get started" |
*
* @param {Ui_Onboarding_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_get_started = /** @type {((inputs?: Ui_Onboarding_Get_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Get_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_get_started(inputs)
	return de_ui_onboarding_get_started(inputs)
});